import { adviceRooms, guests } from 'api';
import { showApiErrorToast } from 'helpers/toasts';

import { mergePayloadWithEntities } from '../entities/actions';
import type { ThunkAction } from '../types';

export const fetchGuestAdviceRoom =
  (authToken: string): ThunkAction<FetchAdviceRoomReturnType> =>
  async dispatch => {
    try {
      const response = await guests()
        .clientMeetingRooms()
        .GET({
          authToken,
          include: ['documents', 'documents.sender', 'client', 'attendees', 'guests'].join(),
        });

      await dispatch(mergePayloadWithEntities(response.data));
    } catch (err) {
      showApiErrorToast(err);
    }
  };

export const fetchAdviceRoom =
  (adviceRoomId: number): ThunkAction<FetchAdviceRoomReturnType> =>
  async dispatch => {
    try {
      const response = await adviceRooms(adviceRoomId).GET({
        include: ['documents', 'documents.sender', 'client', 'attendees', 'guests'].join(),
      });

      await dispatch(mergePayloadWithEntities(response.data));
    } catch (err) {
      showApiErrorToast(err);
    }
  };

export type FetchAdviceRoomReturnType = Promise<void>;
export type FetchAdviceRoomType = (
  ...args: Parameters<typeof fetchAdviceRoom>
) => FetchAdviceRoomReturnType;
